import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/login/login.vue";

const routes = [
    {
        path: "/a/kp",
        component: Login,
        name: "kp",
        meta: {
            nacy: true,
            title: '燃石医学开票'
        }
    }

];

const router = createRouter({
    mode:"hash",
    history: createWebHistory(process.env.BASE_URL),
    routes,
});



export default router;